import {$, T} from "../../common/drupal/drupal";
import { KeyFigureHandler } from "../../common/utilities";
/**
 * Class exemple de gestion du pragraph chiffres-clés
 */
class KeyFigures {

    /**
     * init
     */
    init(){
        new KeyFigureHandler(document.querySelectorAll('.ParagraphKeyNumber-number'), {
            detectPercentage: true,
        });
        
    }

    /**
     * Attach.
     * @param context
     */
    attach(context) {
        if (T.contextIsRoot(context) && $('.ParagraphKeyNumbersBlock-keyNumbers').length > 0) {
            this.init();
        }
    }
}

export let keyFigures = new KeyFigures();
